import React, { Component }           from "react";
import { FontAwesomeIcon }            from '@fortawesome/react-fontawesome'
import { Button, Modal, FormControl } from "react-bootstrap";
import AutoSuggestClientName          from "../../components/autosuggest/AutoSuggestClientName";
import { AdminIdTS, TS_LU, TS_JC }    from "../../utils/StaticIds";
import TableProgramListAllClients     from "../../components/program/TableProgramListAllClients";
import "../../css/modal/ModalSendProgram.css";

export default class ModalSendProgram extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showModalSimple: false,
            clientName: "",
            clientNameSearch: "",
            clientId: "",
            message: false,
            programName: this.props.programName,
            error: "",
            selectedSendUserOption: "athletes"
        };
    }

    componentWillUnmount() {
        // Reset Input Values
        this.setState({
            programName: "",
            clientId: "",
            clientNameSearch: "",
            error: ""
        });
    }

    handleProgramNameChange (event) {
        var program_name = event.target.value;

        this.setState({
            programName: program_name,
            error: ""
        });
    }

    handleSubmit = async event => {
        var program_name = this.state.programName;
        var program_id   = this.props.programId;
        var client_id    = this.state.clientId
        var is_template          = false; // false; it's a program
        var send_to_diff_trainer = false;
        var client_name          = this.state.clientNameSearch;
        var is_priced_template   = this.props.isPricedTemplate;

        if(program_name == "" || program_name == undefined) {

            this.setState({
                error: "A program title is required."
            })
            return false
        }

        if(client_id == "") {
            this.setState({
                error: "A member name needs to be selected."
            })
            return false
        }

        if(this.state.selectedSendUserOption === 'trainers') {
            is_template          = true;
            send_to_diff_trainer = true;
        }

        // Close Modal //
        this.props.onHide();
        this.props.handleDuplicateProgram(program_id, program_name, client_id, is_template, send_to_diff_trainer, client_name, is_priced_template);
    }

    handleMemberNameChange  = (client_id, client_name) => {
        this.setState({
            clientNameSearch: client_name,
            clientId: client_id,
            error: ""
        });
    }


    handleOptionChange = (event) => {
        var option = event.target.value;

        this.setState({
                selectedSendUserOption: option,
                message: true,
                error: ""
        });

        setTimeout(
            function() {
                this.setState({message: false});
            }
            .bind(this), 2000
        );
    }

    getAdminUserId = () => {
       var globalAdminUserId = localStorage.getItem('globalAdminUserId');
       return globalAdminUserId;
    }


     getMemberList () {
         return <TableProgramListAllClients isAuthenticated   = {this.props.isAuthenticated} />
     }

    render() {
        var program_name       = this.state.programName;
        var company_id         = this.props.globalCompanyId;
        var client_name_search = this.state.clientNameSearch;
        var is_priced_template = this.props.isPricedTemplate;
        var is_message         = this.state.message;
        var admin_permission   = false;
        var message;
        var search_trainers;
        var priced_template_text = <br/>

        if(is_message)
            message   = "Search " + this.state.selectedSendUserOption + " ...";

        if(is_priced_template)
            priced_template_text = <div style={{fontSize: 14}}>
                                    (There's a send fee associated with this template.)
                                    </div>

        //if(TS_JC )
        var globalAdminUserId = this.getAdminUserId()

        if(globalAdminUserId === TS_LU || globalAdminUserId === TS_JC) {
            admin_permission = true;
        }

        if(company_id === AdminIdTS) {
            search_trainers = <div style={{position:"relative", top: -8}}>
                                      <span style={{display:"inline-block", width:"100%"}}>
                                              <span className="sendProgramRadioLabel">Search for: </span>
                                              <label className="sendProgramRadioLabel">Athletes</label>
                                              <input type="radio"
                                                     value="athletes"
                                                     checked={this.state.selectedSendUserOption === 'athletes'}
                                                     onChange={this.handleOptionChange} />
                                                 <span className="sendProgramRadioLabel" />
                                              <label className="sendProgramRadioLabel">Trainers</label>
                                              <input type="radio"
                                                     value="trainers"
                                                     checked={this.state.selectedSendUserOption === 'trainers'}
                                                     onChange={this.handleOptionChange} />
                                      </span>
                                </div>
        }
        return (
            <Modal
                    show        = {this.props.show}
                    onHide      = {this.props.onHide}
                    className   = "modalBasics"
              >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title" className="fontSize26px">
                        <FontAwesomeIcon icon="share" className="modalBasicsTitleIcon" />
                        <span className="modalBasicsTitle">
                             Send Program
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <span className="modalBasicsBody">
                          Send <b>{ program_name }</b> program to a member.
                          { priced_template_text }
                          <br/>
                          <div>
                              <div className="modalFormLabelBody">New Program Title</div>
                              <FormControl
                                  onChange={this.handleProgramNameChange.bind(this)}
                                  defaultValue = {program_name}
                                  className="input-lg formModalExerciseField"
                                  style={{fontSize:"20px", border:"2px solid #ccc"}}
                                  type = "text"
                              />
                          </div>
                          <br/>

                          { search_trainers }
                          { /*}<div className="settingsExerciseSaved"> Select{ message }</div>*/ }
                          <div>
                              <div className="modalFormLabelBody">Member</div>
                                  <AutoSuggestClientName
                                       handleMemberNameChange={this.handleMemberNameChange.bind(this)}
                                       //defaultValue = {""}
                                       currentScreen  = "modalSendProgram"
                                       user_type      = {this.state.selectedSendUserOption}
                                       client_name = {client_name_search}
                                       company_id  = {company_id}
                                   />
                               { /*}<TableProgramListAllClients companyId  = {this.props.globalCompanyId}
                                                           isAuthenticated = {this.props.isAuthenticated} />*/ }
                          </div>
                          <br/>
                      <span className="error_text" style={{display:"inline-block",width:"100%", textAlign: "center", color:"red"}}>{this.state.error}</span>
                  </span>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="modalBasicsBtnClose" onClick={this.props.onHide}>Cancel</Button>
                    <span className="modalBasicsFooterXPosSpacer"/>
                    <Button className="modalBasicsBtnOk" onClick={() => this.handleSubmit()}>Send</Button>
                </Modal.Footer>
              </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modal/ModalSendProgram.js